import React, {useContext, useEffect} from 'react'
import Layout from '../../../components/layout/layout'
import './aiInArchitect.scss'
import aiinArchitect1 from '../../../images/articles/aiinArchitect1.jpg'
import aiinArchitect2 from '../../../images/articles/aiinArchitect2.jpg'
import { LanguageContext } from '../../../components/LanguageSwitcher/LanguageContext'
import { ArticleBackLink, ArticleNextCta } from '../../../components/ArticleNav/ArticleNav'
import ArticleCta from '../../../components/ArticleCta/ArticleCta'
import ArticleListen from '../../../components/ArticleListen/ArticleListen'
import ArticleSummary from '../../../components/ArticleSummary/ArticleSummary'
import Seo, { articleJsonLd, articleBreadcrumbs } from '../../../components/Seo/Seo'


const AiInArchitect = () => {
  const { translations } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);


  return (
    <Layout>
      <Seo
        title='Where AI Helps Architects, From Massing to BIM'
        description={translations.BlogaiinArchitect3}
        type='article'
        image={aiinArchitect1}
        jsonLd={[
          articleJsonLd({ headline: translations.BlogaiinArchitect, description: translations.BlogaiinArchitect3, datePublished: '2024-11-12', dateModified: '2026-09-18', author: translations.BlogaiinArchitect21 }),
          articleBreadcrumbs(translations.BlogaiinArchitect, '/articles/aiInArchitect'),
        ]}
      />
      <div className='mlrole-health-container'>
        <div className='mlrole-health healthh-box'>
          <ArticleBackLink />
          <h1 className='article-main-title'>{translations.BlogaiinArchitect}</h1>
          <div className='article-author-head-container'>
            <div className='article-author-head'>
              <p>{translations.BlogaiinArchitect20}</p>
              <p>•</p>
              <p>{translations.BlogaiinArchitect21}</p>
            </div>
            <p className='article-author-head'>{translations.BlogaiinArchitect22}</p>
          </div>

          <div className='mlrole-health-first-image-box'>
            <img src={aiinArchitect1} alt='aidepressivemain' className='mlrole-health-first-image' />
          </div>
          <ArticleListen />
          <ArticleSummary id='aiInArchitect' />
          <div className='mlrole-health-txt-container'>
            <div className='mlrole-health-txt-child-box'>
              <p>{translations.BlogaiinArchitect1}</p>
              <p>{translations.BlogaiinArchitect2}</p>
              <p>{translations.BlogaiinArchitect3}</p>
              <p>{translations.BlogaiinArchitect4}</p>
              <p>{translations.BlogaiinArchitect5}</p>
              <p>{translations.BlogaiinArchitect6}</p>
              <p>{translations.BlogaiinArchitect7}</p>
              <p>{translations.BlogaiinArchitect8} </p>
              <p>{translations.BlogaiinArchitect9}</p>
              <p>{translations.BlogaiinArchitect10}</p>
              <p>{translations.BlogaiinArchitect11}</p>
              <p>{translations.BlogaiinArchitect12}</p>
              <p>{translations.BlogaiinArchitect13}</p>
              <img src={aiinArchitect2} alt='depression1' className='mlroleHealthImage2' />
              <h2 className='article-secondaty-title'>{translations.BlogaiinArchitect14}</h2>
              <p>{translations.BlogaiinArchitect15}</p>
              <p>{translations.BlogaiinArchitect16}</p>
              <p>{translations.BlogaiinArchitect17}</p>
              <p>{translations.BlogaiinArchitect18}</p>
              <p>{translations.BlogaiinArchitect19}</p>
            </div>
          </div>

          <ArticleCta />
          <ArticleNextCta link='/articles/moralRiskHealth' title={translations.Blogmoralrisk} />
        </div>
      </div>
    </Layout>
  )
}

export default AiInArchitect